import { IUploadListItem } from 'core/model/interfaces/downloads-uploads';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../uploads.constants';
import { IUploadsState } from '../uploads.types';

export const fetchAllUploads = createAppAsyncThunk<Array<IUploadListItem>>(
  `${SLICE_NAMESPACE}/fetchAllUploads`,
  async () => {
    try {
      const response = await apiService.uploads.getUploadList();

      return response;
    } catch (error) {
      notificationService.global.error('Falló al cargar la lista de cargas.');

      throw error;
    }
  },
);

export const fetchAllUploadsReducer: TSliceExtraReducer<IUploadsState> = builder =>
  builder
    .addCase(fetchAllUploads.pending, state => {
      state.list.loading = true;
    })
    .addCase(fetchAllUploads.rejected, state => {
      state.list.loading = false;
      state.list.uploads = [];
    })
    .addCase(fetchAllUploads.fulfilled, (state, action) => {
      state.list.loading = false;
      state.list.uploads = action.payload;
    });
